/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const AssessmentResult = {
    ELIGIBLE: 'ELIGIBLE',
    NONELIGIBLE: 'NONELIGIBLE',
    LIMITED: 'LIMITED',
    NONE: 'NONE'
} as const;
export type AssessmentResult = typeof AssessmentResult[keyof typeof AssessmentResult];

